// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:

//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>

// Converts to:

//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>

const links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a")

links.forEach((link) => {
  const image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img, :scope[href$=".webp"] > img')

  if (!image) return

  link.setAttribute("data-fancybox", "")

  const alignsClasses = ["aligncenter", "alignright", "alignleft"]

  alignsClasses.forEach((align) => {
    if (!image.classList.contains(align)) return

    image.classList.remove(align)
    link.classList.add(align)
  })
})
